<a
  [href]="getKeepaLinkUrl()"
  target="_blank"
  class="keepa-graph-container"
  (mouseenter)="op.show($event)"
  (mouseleave)="op.hide()">
  <img
    [src]="getKeepaImageUrl(500, 250)"
    [alt]="'Keepa price history for ' + asin"
    class="keepa-graph-small"
    crossorigin="anonymous" />
</a>

<p-popover
  #op
  [dismissable]="false">
  <div class="keepa-graph-large-container">
    <img
      [src]="getKeepaImageUrl(800, 400)"
      [alt]="'Keepa price history for ' + asin"
      class="keepa-graph-large"
      crossorigin="anonymous" />
  </div>
</p-popover>
